export type Venture = { name: string; body: string; meta: string | null; url?: string };
export type EcosystemPillar = { numeral: string; short: string; title: string; intro: string; ventures: Venture[] };

export const ecosystemPillars: EcosystemPillar[] = [
  {
    numeral: 'Pillar I',
    short: 'Culture',
    title: 'Culture Architecture',
    intro: 'Media, brand and community that turn substance into quiet authority — and attract the right people.',
    ventures: [
      {
        name: 'THE01 Foundation',
        body: 'The cultural foundation of the ecosystem, carrying the 0/1 philosophy into patronage, ideas and long-term initiatives.',
        meta: null,
      },
      {
        name: 'SuperLuxury',
        body: 'A global lifestyle media engine generating cultural authority and attraction for the ecosystem.',
        meta: '1.1M+ followers',
        url: 'https://www.instagram.com/superluxurymedia',
      },
      {
        name: 'LAEBEL',
        body: 'The creative intelligence and visual branding atelier that translates operational reality into authoritative brand aesthetics.',
        meta: 'Studios · Ventures',
        url: 'https://laebel.com',
      },
    ],
  },
  {
    numeral: 'Pillar II',
    short: 'Capital',
    title: 'Capital Architecture',
    intro: 'Structures engineered to generate, qualify and scale wealth through selective curation.',
    ventures: [
      {
        name: 'The Venture',
        body: 'The investment vehicle of the house, building and backing companies that share its standard of quality.',
        meta: null,
      },
      {
        name: 'REALTI Group',
        body: 'An intelligence-led real estate platform giving qualified investors access to off-market developments across Dubai, Mallorca and Poland (REALTI DI).',
        meta: null,
        url: 'https://realti.group',
      },
      {
        name: 'INEQ',
        body: 'Equity infrastructure serving as a qualified bridge between CEE property developers and DACH institutional and private capital.',
        meta: null,
        url: 'https://ineq.de',
      },
    ],
  },
  {
    numeral: 'Pillar III',
    short: 'Longevity',
    title: 'Longevity Architecture',
    intro: 'Structures that optimise the human operating system — the true baseline for sustained wealth.',
    ventures: [
      {
        name: 'IOA',
        body: 'The private, highly qualified network where capital operators and longevity practitioners physically converge.',
        meta: 'Private',
      },
      {
        name: 'Retreatic',
        body: 'Highly curated B2C and B2B longevity retreats worldwide, built to restore time and mental space.',
        meta: null,
      },
      {
        name: 'Erfolgsmensch',
        body: 'A leading DACH community focused on Beyond High Performance across six dimensions of life.',
        meta: '320,000+ members',
      },
    ],
  },
];
